// TODO use location instead of window.location.pathname
export function getSearchLocationUtil () {
  return window.location.search
}
